export default {
  home: 'خانه',
  rastech: 'هاسپیتک',
  contentSettings: 'تنظیمات',
  documents: 'مدیریت محتوا',
  tags: 'برچسب‌ها',
  templateManagement: 'مدیریت قالب‌ها',
  quickView: 'دسترسی سریع',
  managingCompanyTasks(companyName: string) {
    return `وظایف ${companyName}`;
  },
};
